// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Gt-z","tooltipWrapper":"Ht-z","icon":"It-z","tooltip":"Jt-z","content":"Kt-z"};